/* unplugin-vue-components disabled */import script from "./Avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=e1e6b0e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e6b0e6"]])

export default __exports__